import router from '@/router.js'
import token from '@/utils/token.js'
import { Message } from 'view-design'
import store from '@/store.js'

const whiteList = ['/login', '/thirdlogin']

//路由跳转前
router.beforeEach((to, from, next) => {
    if(to.query.ldpToken){
        next()
    }else{
        if (to.path === "/thirdlogin" || to.path === "/singleLogin" || to.path === "/BI.html") {
            next()
            return;
        }
        //用户权限
        let permissionMenu = [];
        let permissionAll = JSON.parse(localStorage.getItem("permission"));
        if (permissionAll) {
            permissionMenu = permissionAll.filter((p) => p.privilegeType == "0");
        }
        let userPages = [];
        for (let menu of permissionMenu) {
            userPages.push(menu.privilegeCode);
        }
        if (token.getToken()) {
            console.log(to.path,888)
            if (to.path === "/login") {
                next()
            } else if (to.meta.permissionCode != 'universal' && !userPages.includes(to.meta.permissionCode) && to.path != "/") {
                Message.error('无权访问该页面');
            }
            else {
                next()
            }
        } else {
            if (whiteList.indexOf(to.path) >= 0 || to.path === '/noUser') {
                next()
            } else {
                next('/login')
            }
        }
    }
    
});